import useQuizCompleted from "~/hooks/useQuizCompleted";

import { QUIZ_CATEGORIES } from "~/constants/questionnaire";

const allowedCatgories: string[] = [
    QUIZ_CATEGORIES.LIBIDA,
    QUIZ_CATEGORIES.FACE_CREAM,
    QUIZ_CATEGORIES.FACE_CREAM_REDESIGN,
];

export const useSkipQuiz = (category: string) => {
    const { isCompleted: isOestraCompleted, isChecking } = useQuizCompleted("");

    if (!allowedCatgories.includes(category)) {
        return false;
    }

    return isChecking ? false : isOestraCompleted;
};

export default useSkipQuiz;
